import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination"
import { TimepickerModule } from 'ngx-bootstrap/timepicker'

import { MomentModule } from 'ngx-moment';

import {
	DeleteConfirmationComponent
} from './../shared/index';

import {
    UserIndexComponent,
	UserListComponent,
	UserFilterComponent,
	OrderByPipe
    //UserSearchComponent,
} from './index';
import { UserRouting } from './index';


@NgModule({
    imports: [
        BsDatepickerModule,
        ModalModule,
        MomentModule,
        PaginationModule.forRoot(),
        TimepickerModule,

        CommonModule,
        UserRouting,
		FormsModule
    ],
    declarations: [
        UserIndexComponent,
		UserListComponent,
		UserFilterComponent,
		OrderByPipe
    ],
	providers: [
		OrderByPipe
        //CatalogResolve
    ]
})
export class UserModule { }
